import { createAction, props } from '@ngrx/store';
import { TransactionAuthorizationResult } from '@arc/unified-payments-frontend/shared-payment';

export const updateTransactionAuthorizationResults = createAction(
  '[POI Intl BTPay Payment Confirmation] Update Transaction Authorization Results',
  props<{
    transactionAuthorizationResult: TransactionAuthorizationResult[];
    transactionReference: string;
  }>(),
);
